import { CustomerAddressPosition } from "@/types/customer/address.type";

export class CustomerPosition {
  latitude: string = "";
  longitude: string = "";

  constructor(position: CustomerAddressPosition) {
    this.latitude = position?.latitude;
    this.longitude = position?.longitude;
  }

  setPosition(lat, lng) {
    this.latitude = lat;
    this.longitude = lng;
  }

  getLatLng(): any {
    return {
      lat: parseFloat(this.latitude),
      lng: parseFloat(this.longitude),
    };
  }
  getPosition(): any {
    return {
      latitude: this.latitude,
      longitude: this.longitude,
    };
  }

  position(): any {
    return {
      latitude: this.latitude,
      longitude: this.longitude,
      lat: parseFloat(this.latitude),
      lng: parseFloat(this.longitude),
    };
  }

  /**
   * Get Full position info
   * @return {any}
   */
  getFullPosition(): any {
    return {
      latitude: parseFloat(this.latitude),
      longitude: parseFloat(this.longitude),
      lat: parseFloat(this.latitude),
      lng: parseFloat(this.longitude),
    };
  }
}
